import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e0395fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "flex-grow border-2" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "bg-gray-300 px-2 plus-button" }, "+", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListAdd = _resolveComponent("ListAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-add-line", {closed: !_ctx.showInput}])
  }, [
    (!_ctx.showInput)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInput = true)),
          class: "cursor-pointer flex plus-wrap"
        }, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 512)), [
          [_vShow, _ctx.showInput]
        ])
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_ListAdd, { onAdd: _ctx.add }, null, 8, ["onAdd"]), [
      [_vShow, _ctx.showInput]
    ])
  ], 2))
}